import { useLocation } from "react-router-dom";

import { useIsStandaloneProducts } from "modules/standaloneProducts/standaloneProductsPaths";
import { useFeatureFlag } from "services/Flags";

const GIFT_CARDS_PATH_PREFIX = "/gift-cards";

/**
 * Whether the app lays out for desktop widths. The gift-card and products-only storefront pages are
 * embedded in a practice's own site and are always full width, whatever `desktopExperience` says.
 */
export const useIsDesktopLayout = () => {
  const isDesktopExperience = useFeatureFlag("desktopExperience");
  const { pathname } = useLocation();
  const isStandaloneProducts = useIsStandaloneProducts();
  const isGiftCardPage =
    pathname === GIFT_CARDS_PATH_PREFIX || pathname.startsWith(`${GIFT_CARDS_PATH_PREFIX}/`);

  return isDesktopExperience || isGiftCardPage || isStandaloneProducts;
};
